import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import { ContactService, UserService } from "@/services";
const CountDown = () =>
  import(/* webpackChunkName: "count-down" */ "@/components/CountDown/index");

export default {
  name: "email-input",
  components: {
    CountDown
  },
  data() {
    return {
      emailInput: "",
      emailCode: "",
      isCountDownFinish: false,
      ttl: 0,
      isRequesting: false,
      isModalOpen: false
    };
  },
  mounted() {},
  computed: {
    ...mapGetters({
      modalStep: types.email.getters.MODAL_STEP,
      userInfo: types.userInfo.getters.GET_USER_INFO,
      userVerify: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),

    isEmailValid() {
      const emailRegex = /\S+@\S+\.\S+/;
      if (this.emailInput) {
        return emailRegex.test(this.emailInput.toLowerCase());
      }
      return false;
    },
    isEmailCodeValid() {
      if (this.emailCode) {
        const emailRegex = /^\d{1,6}$/;
        return emailRegex.test(this.emailCode);
      }
      return false;
    },
    email() {
      this.emailInput = this.userInfo?.email;
      return this.userInfo?.email;
    },
    isEmailVerify() {
      return this.userVerify?.is_email_verified === true;
    }
  },
  methods: {
    ...mapActions({
      setEmail: types.userVerifyInfo.actions.SET_EMAIL_STATUS,
      setVerifyData: types.userVerifyInfo.actions.SET_USER_VERIFY_INFO,
      setUserData: types.userInfo.actions.ACTION_USER_INFO
    }),
    closeEmailModal() {
      this.isModalOpen = false;
    },
    handleFinishCountDown() {
      this.isCountDownFinish = true;
      this.ttl = 0;
    },
    verifyEmail() {
      if (this.isEmailCodeValid) {
        ContactService.verifyEmail(this.emailCode)
          .then(res => {
            this.setEmail("VERIFIED");
            this.closeEmailModal();
            this.getUserInfo();
            this.getAuthVerifyInfo();
            this.$toast.success(res.data.message);
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      }
    },
    startRequest() {
      this.isRequesting = true;
    },

    finishRequest() {
      this.isRequesting = false;
    },
    openEmailModal() {
      this.activeEmail();
      this.isModalOpen = true;
    },
    checkValidation() {
      this.errorText = "";
      if (this.emailInput) {
        if (!this.isEmailValid) {
          this.errorText = this.$t(
            "accountPage.identityInformation.contactInfo.email.emailValidation.invalid"
          );
        }
      } else {
        this.errorText = this.$t(
          "accountPage.identityInformation.contactInfo.email.emailValidation.empty"
        );
      }
    },
    activeEmail() {
      this.checkValidation();
      if (this.emailInput) {
        ContactService.activeEmail(this.emailInput)
          .then(res => {
            this.ttl = res.data.data.ttl;
            this.resetCounter();
            this.setStep(2);
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      }
    },
    reActiveEmail() {
      ContactService.activeEmail(this.emailInput)
        .then(res => {
          this.ttl = res.data.data.ttl;
          this.resetCounter();
        })
        .finally(() => this.finishRequest());
      this.startRequest();
    },
    resetCounter() {
      this.isCountDownFinish = false;
    },
    getAuthVerifyInfo() {
      UserService.getVerifyInfo().then(response => {
        this.setVerifyData(response.data.data);
      });
    },
    getUserInfo() {
      UserService.getInfo().then(response => {
        this.setUserData(response.data.data);
      });
    }
  }
};
